import Navbar from "./navbar";
import React, { useState } from "react";

import {
  Route,
  Routes,
  Navigate
} from "react-router-dom";

import Home from "./pages/Home";
import Location from "./pages/Location";
import Register from "./pages/Register";
import CheckPoints from "./pages/Points";
import MyDetails from "./pages/MyDetails";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Profile from "./pages/Profile";
import Footer from "./pages/footer";

import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/check" element={<CheckPoints />} />
        <Route path="/mydetails" element={<MyDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar
        theme="dark"
      />

      <Footer />
    </>
  );
}

export default App;
